import logo from 'assets/img/logo.png'
import EnvBadge from 'components/envBadge'
import UserName from 'components/userName'
import { Link } from 'react-router-dom'
import { PAGE_DASHBOARD } from 'utils/constants'

const Header = () => {
  return (
    <header className="header-top flex items-center justify-between gap-3 px-2 py-3 sm:px-10">
      <div className="w-28 shrink-0">
        <Link to={PAGE_DASHBOARD.path}>
          <img
            src={logo}
            alt="gag-logo"
            className="h-full w-full object-contain"
          />
        </Link>
      </div>

      <div className="flex items-center gap-4">
        <EnvBadge />
        <UserName />
      </div>
    </header>
  )
}

export default Header
